module.exports = __webpack_public_path__ + "img/parter-work3.fa21f7df.png";